
import { Vue, Component, Prop } from 'vue-property-decorator';
import { KAMU_EMEKLI_KAYIT_DISI_ALANLAR, KamuEmekliCevap, kamuEmekliKayitlari } from '@/plugins/uyap-plugin/uyap/KamuEmekli';

interface KayitAlani {
  ad: string,
  etiket: string,
  deger: string
}

@Component({})
export default class KamuEmekliDetay extends Vue {
  @Prop() data!: KamuEmekliCevap;

  get emekliKayitlari() {
    return kamuEmekliKayitlari(this.data?.sorguSonucDVO);
  }

  // Yalnız dolu metin/sayı/evet-hayır alanları gösterilir; iç içe nesneler ham JSON olarak basılmaz.
  get kayitAlanlari(): Array<Array<KayitAlani>> {
    return this.emekliKayitlari
        .map(kayit => this.duzAlanlar(kayit))
        .filter(alanlar => alanlar.length > 0);
  }

  // Kayıt tek bir alt nesnede de gelebilir ({emekliKaydi4c: {...}}); bir alt seviyedeki düz alanlar da alınır.
  duzAlanlar(kayit: Record<string, any>, ust = ''): Array<KayitAlani> {
    return Object.keys(kayit)
        .filter(ad => !KAMU_EMEKLI_KAYIT_DISI_ALANLAR.includes(ad))
        .flatMap(ad => {
          const deger = kayit[ad];
          if (!ust && deger && typeof deger === 'object' && !Array.isArray(deger))
            return this.duzAlanlar(deger, ad + '.');
          return [{ad: ust + ad, etiket: this.etiket(ad), deger: this.deger(deger)}];
        })
        .filter(alan => alan.deger !== '');
  }

  get hasData() {
    return this.kayitAlanlari.length > 0;
  }

  deger(deger: any): string {
    if (typeof deger === 'string')
      return deger.trim();
    if (typeof deger === 'number')
      return String(deger);
    if (typeof deger === 'boolean')
      return deger ? 'Evet' : 'Hayır';
    return '';
  }

  // Alan adları bilinmediği için okunur hale getirilir: "aylikBaslangicTarihi" -> "Aylik Baslangic Tarihi"
  etiket(ad: string): string {
    const metin = ad.replace(/([a-zçğıöşü0-9])([A-ZÇĞİÖŞÜ])/g, '$1 $2');
    return metin.charAt(0).toLocaleUpperCase('tr') + metin.slice(1);
  }
}
